import React, { useEffect, useState } from "react";
import "./FloorPlan.css";
import { getAlarmTolaranceDetail } from "./services";
import { useNavigate } from "react-router-dom";

const FloorPlan = ({ isFloorPlanZoomed, mergedArray }) => {
  const [alarmToleranceData, setAlarmToleranceData] = useState({});
  const [actualMachineData, setActualMachineData] = useState({});

  useEffect(() => {
    const fetchAlarmToleranceDetail = async () => {
      try {
        const response = await getAlarmTolaranceDetail();
        if (response.data.payload) {
          const allToleranceData = [
            ...(response.data.payload.prong_oven || []),
            ...(response.data.payload.tunnel_oven || []),
            ...(response.data.payload.leaching || []),
            ...(response.data.payload.dipping || []),
            ...(response.data.payload.ac_conditioning || []),
            ...(response.data.payload.extra_ac_conditioning || []),
            ...(response.data.payload.washing_1 || []),
            ...(response.data.payload.washing_2 || []),
            ...(response.data.payload.tumble_dryer || []),
            ...(response.data.payload.ultrasonic || []),
            ...(response.data.payload.auto_clave || []),
          ];

          const toleranceMap = allToleranceData.reduce((acc, item) => {
            acc[item.machine_tag] = {
              set_temp: parseFloat(item.set_temp),
              tolerance: parseFloat(item.tolerance),
              
            };
            return acc;
          }, {});
          setAlarmToleranceData(toleranceMap);
        }
      } catch (error) {
        console.error("Error fetching alarm tolerance detail:", error);
      }
    };
    fetchAlarmToleranceDetail();
  }, []);

  // Helper function to map oven name to its device_tag
  const getProngOvenTagKey = (ovenName) => {
    // This function needs to match how your device_tags are named
    // Based on your example (PRO_4_ACT_TEMP), it seems to be PRO_{index}_ACT_TEMP
    // You might need to adjust this logic based on your actual tag naming convention for all machine types.
    if (ovenName.includes("Prong Oven")) {
      const ovenNumber = ovenName.replace("Prong Oven ", "");
      return `PRO_${ovenNumber}_ACT_TEMP`;
    }
    // Add similar logic for other machine types (Tunnel Oven, Leaching, etc.)
    // Example for "Big Oven" if it has a specific tag
    if (ovenName === "Big Oven") {
      return "BIG_ACT_TEMP"; // Replace with actual tag
    }
    if (ovenName === "Auto Clave") {
      return "AUTCLV_ACT_TEMP"; // Replace with actual tag
    }
    if (ovenName === "AC Room 1") {
      return "AC_ROOM_1_TEMP"; // Replace with actual tag
    }
    if (ovenName === "AC Room 2") {
      return "EXTRA_AC_TEMP"; // Replace with actual tag
    }
    if (ovenName === "ultrasonic") {
      return [
        "ULRASONIC_T_ACT_TEMP",
        "RINSING_T_ACT_TEMP",
        "H_AIR_DRYR_T_ACT_TEMP",
      ]; // Replace with actual tag
    }
    if (ovenName === "hotLeaching") {
      return "HOT_LECH_T_ACT_TEMP"; // Replace with actual ta
    }
    if (ovenName === "robot 1") {
      return "TEMPERATURE_1"; // Replace with actual ta
    }
    if (ovenName === "robot 2") {
      return "TEMPERATURE_2"; // Replace with actual ta
    }
    if (ovenName === "tumbleDryer") {
      return "DRYER_TEMP"; // Replace with actual ta
    }
    if (ovenName === "washing 1") {
      return "WASHING_TEMP"; // Replace with actual ta
    }
    if (ovenName === "washing 2") {
      return "WASHING_MC_2_TEMP"; // Replace with actual ta
    }
    if (ovenName === "Tunnel Oven") {
      return [
        "TUNL_OVN_Z1_ACT_TEMP",
        "TUNL_OVN_Z2_ACT_TEMP",
        "TUNL_OVN_Z3_ACT_TEMP",
        "TUNL_OVN_Z4_ACT_TEMP",
        "TUNL_OVN_Z5_ACT_TEMP",
        "TUNL_OVN_Z6_ACT_TEMP",
        "TUNL_OVN_Z7_ACT_TEMP",
        "TUNL_OVN_Z8_ACT_TEMP",
      ];
    }
    // Return the ovenName itself if it directly corresponds to a tag, or handle other cases
    return ovenName; // Default, if no specific mapping is found
  };

  // Helper function to determine if a machine is in an alarm state
  const getAlarmClass = (deviceTag) => {
    // Handle array of device tags for machines like Tunnel Oven
    if (Array.isArray(deviceTag)) {
      for (const tag of deviceTag) {
        const toleranceInfo = alarmToleranceData[tag];
        const machineData = mergedArray?.find((e) => e.device_tag === tag);
        const actualTemp =
          machineData?.tagValue !== undefined &&
          machineData.tagValue !== null &&
          machineData.tagValue !== ""
            ? parseFloat(machineData.tagValue)
            : undefined;

        if (toleranceInfo && actualTemp !== undefined) {
          const lowerBound = toleranceInfo.set_temp - toleranceInfo.tolerance;
          const upperBound = toleranceInfo.set_temp + toleranceInfo.tolerance;
          if (actualTemp < lowerBound || actualTemp > upperBound) {
            return "alarm-highlight"; // If any zone is in alarm, return highlight
          }
        }
      }
    } else {
      // Original logic for single device tags
      const toleranceInfo = alarmToleranceData[deviceTag];
      const machineData = mergedArray?.find((e) => e.device_tag === deviceTag);
      const actualTemp =
        machineData?.tagValue !== undefined &&
        machineData.tagValue !== null &&
        machineData.tagValue !== ""
          ? parseFloat(machineData.tagValue)
          : undefined;

      if (toleranceInfo && actualTemp !== undefined) {
        const lowerBound = toleranceInfo.set_temp - toleranceInfo.tolerance;
        const upperBound = toleranceInfo.set_temp + toleranceInfo.tolerance;
        if (actualTemp < lowerBound || actualTemp > upperBound) {
          return "alarm-highlight";
        }
      }
    }
    return ""; // No alarm
  };

  const handleFloorSectionClick = (ovenName, machineName) => {
    if (getAlarmClass(getProngOvenTagKey(ovenName)) === "alarm-highlight") {
      window.location.href = `/alarm?machine_name=${encodeURIComponent(machineName)}`;
    }
  };
  

  return (
    <div className={`plans-wrapper ${isFloorPlanZoomed ? "zoom-in" : ""}`}>
      {!isFloorPlanZoomed && (
        <div
          style={{
            border: "1px solid ",
            width: "86%",
            height: "471px",
            position: "absolute",
            left: "8%",
          }}
        ></div>
      )}
      <div
        className={`floor-plan-container ${isFloorPlanZoomed ? "zoom-in" : ""}`}
        style={{
          width: isFloorPlanZoomed ? "1012px" : "957px",
          transform: !isFloorPlanZoomed ? "scale(0.40)" : "scale(0.9)",
          left: !isFloorPlanZoomed ? "-20%" : "unset",
        }}
      >
        <div
          style={{
            position: "absolute",
            left: 45,
            top: "203px",
            width: "800px",
            height: "400px",
            textAlign: "center",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#4a4a4a",
          }}
        >
          GLOVES MANUFACTURING AREA
        </div>
        <div
          className="floor-section"
          style={{
            left: "179px",
            top: -7,
            height: 50,
            width: 200,
            fontSize: 13,
            letterSpacing: 3,
            border: "none",
            background: "none",
            fontWeight: "bold",
          }}
        >
          WALK
        </div>
        <div
          className="floor-section"
          style={{ left: "70px", top: "34px", height: "50px", width: "200px" }}
        >
          COLD LEACHING TANK
        </div>
        <div
          className={`floor-section ${getAlarmClass(
            getProngOvenTagKey("hotLeaching")
          )}`}
          onClick={() => handleFloorSectionClick("hotLeaching","Leaching")}
          style={{ left: "300px", top: "34px", height: "50px", width: "200px" }}
        >
          HOT LEACHING TANK
        </div>
        <div
          className={`floor-section ${getAlarmClass(
            getProngOvenTagKey("Tunnel Oven")
          )}`}
          onClick={() => handleFloorSectionClick("Tunnel Oven","Tunnel Oven")}
          style={{ left: "70px", top: "94px", height: "50px", width: "430px" }}
        >
          TUNNEL OVEN
        </div>
        <div
          className="floor-section"
          style={{
            left: "228px",
            top: "153px",
            height: "30px",
            width: "120px",
          }}
        >
          Beading Station
        </div>
        <div
          className="floor-section rotated-text"
          style={{
            left: "8px",
            top: "33px",
            height: "200px",
            width: "50px",
            fontSize: 13,
            letterSpacing: 3,
            border: "none",
            background: "none",
            fontWeight: "bold",
          }}
        >
          <span style={{ transform: "rotate(-90deg)" }}>WALKWAY</span>
        </div>
        <div
          className="floor-section rotated-text"
          style={{ left: "8px", top: "270px", height: "200px", width: "50px" }}
        >
          <span style={{ transform: "rotate(-90deg)" }}>STRIPPING STATION</span>
        </div>
        <div
          className={`floor-section rotated-text ${getAlarmClass(
            getProngOvenTagKey("Big Oven")
          )}`}
          onClick={() => handleFloorSectionClick("Big Oven","Big Oven")}
          style={{ left: "9px", top: "490px", height: "200px", width: "50px" }}
        >
          <span style={{ transform: "rotate(-90deg)" }}>BIG OVEN</span>
        </div>

        <div
          className={`floor-section ${getAlarmClass(
            getProngOvenTagKey("Prong Oven 2")
          )}`}
          onClick={() => handleFloorSectionClick("Prong Oven 2","Prong Oven 2")}
          style={{
            left: -2,
            top: 710,
            height: 60,
            width: 80,
            transform: "rotate(-90deg)",
            position: "absolute",
          }}
        >
          OVEN 2
        </div>
        <div
          className={`floor-section ${getAlarmClass(
            getProngOvenTagKey("Prong Oven 1")
          )}`}
          onClick={() => handleFloorSectionClick("Prong Oven 1","Prong Oven 1")}
          style={{
            left: 0,
            top: 796,
            height: 60,
            width: 75,
            transform: "rotate(-90deg)",
            position: "absolute",
          }}
        >
          OVEN 1
        </div>
        <div
          className={`floor-section ${getAlarmClass(
            getProngOvenTagKey("Prong Oven 4")
          )}`}
          onClick={() => handleFloorSectionClick("Prong Oven 4","Prong Oven 4")}
          style={{
            left: 83,
            top: 535,
            height: 60,
            width: 80,
            transform: "rotate(-90deg)",
            position: "absolute",
          }}
        >
          OVEN 4
        </div>
        <div
          className={`floor-section ${getAlarmClass(
            getProngOvenTagKey("Prong Oven 6")
          )}`}
          onClick={() => handleFloorSectionClick("Prong Oven 6","Prong Oven 6")}
          style={{
            left: 83,
            top: 621,
            height: 60,
            width: 80,
            transform: "rotate(-90deg)",
            position: "absolute",
          }}
        >
          OVEN 6
        </div>
        <div
          className={`floor-section ${getAlarmClass(
            getProngOvenTagKey("Prong Oven 5")
          )}`}
          onClick={() => handleFloorSectionClick("Prong Oven 5","Prong Oven 5")}
          style={{
            left: 83,
            top: 708,
            height: 60,
            width: 80,
            transform: "rotate(-90deg)",
            position: "absolute",
          }}
        >
          OVEN 5
        </div>
        <div
          className={`floor-section ${getAlarmClass(
            getProngOvenTagKey("Prong Oven 3")
          )}`}
          onClick={() => handleFloorSectionClick("Prong Oven 3","Prong Oven 3")}
          style={{
            left: 83,
            top: 798,
            height: 60,
            width: 80,
            transform: "rotate(-90deg)",
            position: "absolute",
          }}
        >
          OVEN 3
        </div>

        <div
          className="floor-section"
          style={{
            left: 72,
            top: 270,
            height: 36,
            width: 60,
            position: "absolute",
          }}
        >
          UID Printing
        </div>

        <div
          className="floor-section"
          style={{
            left: 70,
            top: 315,
            height: 59,
            width: 65,
            transform: "rotate(90deg)",
            position: "absolute",
          }}
        >
          Conveyor VRC
        </div>

        <div
          className="floor-section"
          style={{
            left: 141,
            top: 309,
            height: 41,
            width: 80,
            position: "absolute",
          }}
        >
          VISUAL INSPECTION
        </div>

        <div
          className="floor-section-1"
          style={{
            left: 247,
            top: 288,
            height: 52,
            width: 69,
            zIndex: 999,
            position: "absolute",
          }}
        >
          Pillows Goods If VRC
        </div>

        <div
          className="floor-section"
          style={{
            left: 149,
            top: 427,
            height: 30,
            width: 60,
            position: "absolute",
          }}
        >
          Tumbler
        </div>

        <div
          className={`floor-section ${getAlarmClass(
            getProngOvenTagKey("tumbleDryer")
          )}`}
          onClick={() => handleFloorSectionClick("tumbleDryer","Tumble Dryer")}
          style={{
            left: 89,
            top: 464,
            height: 30,
            width: 60,
            position: "absolute",
          }}
        >
          Dryer
        </div>

        <div
          className={`floor-section ${getAlarmClass(
            getProngOvenTagKey("washing 1")
          )}`}
          onClick={() => handleFloorSectionClick("washing 1","Washing 1")}
          style={{
            left: 155,
            top: 463,
            height: 30,
            width: 60,
            position: "absolute",
          }}
        >
          Washing
        </div>

        <div
          className="floor-section-1"
          style={{
            left: 242,
            top: 284,
            height: 203,
            width: 344,
            position: "absolute",
          }}
        ></div>

        <div
          style={{
            left: 316,
            top: 300,
            height: 30,
            width: 300,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "0.75rem",
            color: "#333",
            padding: 2,
            position: "absolute",
            textAlign: "center",
          }}
        >
          ABOVE MEZZENINE FLOOR
        </div>

        <div
          className={`floor-section ${getAlarmClass(
            getProngOvenTagKey("ultrasonic")
          )}`}
          onClick={() => handleFloorSectionClick("ultrasonic","Ultrasonic Machine")}
          style={{
            left: 343,
            top: 350,
            height: 60,
            width: 150,
            position: "absolute",
          }}
        >
          Ultra Sonic M/C with Jet Wash
        </div>
        <div
          className={`floor-section ${getAlarmClass(
            getProngOvenTagKey("Auto Clave")
          )}`}
          onClick={() => handleFloorSectionClick("Auto Clave","Autoclave")}
          style={{
            left: 485,
            top: 371,
            position: "absolute",
            height: 60,
            width: 126,
            transform: "rotate(90deg)",
          }}
        >
          AUTOCLAVE
        </div>

        <div
          className="floor-section circle"
          style={{
            left: 423,
            top: 450,
            position: "absolute",
          }}
        >
          CUTTING M/C
        </div>
        <div
          className="floor-section-1"
          style={{
            left: 738,
            top: 1,
            height: 21,
            width: 49,
            position: "absolute",
          }}
        >
          Bettery
        </div>
        <div
          className="floor-section-1"
          style={{
            left: 798,
            top: 1,
            height: 21,
            width: 49,
            position: "absolute",
          }}
        >
          UPS
        </div>
        <div
          className="floor-section"
          style={{
            left: 615,
            top: 27,
            height: 38,
            width: 150,
            position: "absolute",
          }}
        >
          Rack Dismantling Tilting Str.
        </div>

        <div
          className="floor-section"
          style={{
            left: 673,
            top: 129,
            height: 30,
            width: 150,
            transform: "rotate(90deg)",
            position: "absolute",
          }}
        >
          Unloading Stn.
        </div>

        <div
          className={`floor-section ${getAlarmClass(
            getProngOvenTagKey("robot 2")
          )}`}
          onClick={() => handleFloorSectionClick("robot 2","Dipping")}
          style={{
            left: 774,
            top: 57,
            height: 30,
            width: 64,
            position: "absolute",
          }}
        >
          ROBOT=2
        </div>

        <div
          className={`floor-section ${getAlarmClass(
            getProngOvenTagKey("robot 1")
          )}`}
          onClick={() => handleFloorSectionClick("robot 1","Dipping")}
          style={{
            left: 773,
            top: 218,
            height: 30,
            width: 66,
            position: "absolute",
          }}
        >
          ROBOT=1
        </div>

        <div
          className="floor-section"
          style={{
            left: 641,
            top: 222,
            height: 30,
            width: 100,
            position: "absolute",
          }}
        >
          Rack Assy Stn.
        </div>

        <div
          className="floor-section"
          style={{
            left: 739,
            top: 265,
            height: 60,
            width: 101,
            position: "absolute",
          }}
        >
          DIPPING OVEN
        </div>

        <div
          className="floor-section"
          style={{
            left: 651,
            top: 330,
            height: 59,
            width: 280,
            position: "absolute",
          }}
        >
          {" "}
          Robot Control Panels
        </div>

        <div
          className="floor-section"
          style={{
            left: 850,
            top: 31,
            height: 40,
            width: 80,
            position: "absolute",
          }}
        >
          Tank L
        </div>

        <div
          className="floor-section"
          style={{
            left: 850,
            top: 78,
            height: 40,
            width: 80,
            position: "absolute",
          }}
        >
          Tank L
        </div>

        <div
          className="floor-section"
          style={{
            left: 850,
            top: 124,
            height: 40,
            width: 80,
            position: "absolute",
          }}
        >
          Tank C
        </div>

        <div
          className="floor-section"
          style={{
            left: 850,
            top: 193,
            height: 40,
            width: 80,
            position: "absolute",
          }}
        >
          Tank L
        </div>

        <div
          className="floor-section"
          style={{
            left: 850,
            top: 238,
            height: 40,
            width: 80,
            position: "absolute",
          }}
        >
          Tank C
        </div>

        <div
          className="floor-section"
          style={{
            left: 850,
            top: 283,
            height: 40,
            width: 80,
            position: "absolute",
          }}
        >
          Tank C
        </div>
        <div
          className="floor-section"
          style={{
            left: 936,
            top: 15,
            height: 367,
            width: 62,
            position: "absolute",
          }}
        ></div>

        <div
          className="floor-section circle"
          style={{
            left: 950,
            top: 19,
            height: 35,
            width: 35,
            position: "absolute",
          }}
        >
          M6
        </div>
        <div
          className="floor-section circle"
          style={{
            left: 950,
            top: 58,
            height: 35,
            width: 35,
            position: "absolute",
          }}
        >
          M5
        </div>
        <div
          className="floor-section circle"
          style={{
            left: 950,
            top: 98,
            height: 35,
            width: 35,
            position: "absolute",
          }}
        >
          M4
        </div>

        <div
          className="floor-section circle"
          style={{
            left: 950,
            top: 138,
            height: 35,
            width: 35,
            position: "absolute",
          }}
        >
          M3
        </div>

        <div
          className="floor-section circle"
          style={{
            left: 950,
            top: 178,
            height: 35,
            width: 35,
            position: "absolute",
          }}
        >
          M2
        </div>

        <div
          className="floor-section circle"
          style={{
            left: 950,
            top: 218,
            height: 35,
            width: 35,
            position: "absolute",
          }}
        >
          M1
        </div>

        <div
          className="floor-section circle"
          style={{
            left: 950,
            top: 259,
            height: 35,
            width: 35,
            position: "absolute",
          }}
        >
          D3
        </div>

        <div
          className="floor-section circle"
          style={{
            left: 950,
            top: 300,
            height: 35,
            width: 35,
            position: "absolute",
          }}
        >
          D2
        </div>

        <div
          className="floor-section circle"
          style={{
            left: 950,
            top: 340,
            height: 35,
            width: 35,
            position: "absolute",
          }}
        >
          D1
        </div>

        <div
          className="floor-section-1"
          style={{
            left: 632,
            top: 395,
            height: 147,
            width: 368,
            position: "absolute",
          }}
        ></div>

        <div
          className="floor-section-1"
          style={{
            left: "740px",
            top: 408,
            position: "absolute",
            border: "none",
          }}
        >
          ABOVE MEZZENINE FLOOR
        </div>

        <div
          className="floor-section-1 circle"
          style={{
            left: 941,
            top: 403,
            height: 55,
            width: 55,
            position: "absolute",
          }}
        >
          Cutout for tank
        </div>

        <div
          className="floor-section-1 circle"
          style={{
            left: 941,
            top: 480,
            height: 55,
            width: 55,
            position: "absolute",
          }}
        >
          Cutout for tank
        </div>

        <div
          className="floor-section-1"
          style={{
            left: 237,
            top: 605,
            height: 50,
            width: 500,
            position: "absolute",
          }}
        >
          GLOVES FG STORAGE RACK
        </div>

        <div
          className="floor-section-1"
          style={{
            left: 239,
            top: 816,
            height: 50,
            width: 500,
            position: "absolute",
          }}
        >
          GLOVES FG STORAGE RACK
        </div>

        <div
          className="floor-section-1 "
          style={{
            left: 760,
            top: 663,
            height: 40,
            width: 189,
            position: "absolute",
          }}
        >
          {/* <span
            style={{
              transform: "rotate(-90deg)",
              display: "inline-block",
            }}
          > */}
          GLOVES FG STORAGE RACK
          {/* </span> */}
        </div>

        <div
          className="floor-section-1"
          style={{
            left: 760,
            top: 713,
            height: 40,
            width: 189,
            position: "absolute",
          }}
        >
          {/* <span
            style={{
              transform: "rotate(-90deg)",
              display: "inline-block",
            }}
          > */}
          GLOVES FG STORAGE RACK
          {/* </span> */}
        </div>

        <div
          className="floor-section-1"
          style={{
            left: 760,
            top: 759,
            height: 40,
            width: 189,
            position: "absolute",
          }}
        >
          {/* <span
            style={{
              transform: "rotate(-90deg)",
              display: "inline-block",
            }}
          > */}
          GLOVES FG STORAGE RACK
          {/* </span> */}
        </div>

        <div
          className="floor-section"
          style={{
            left: 672,
            top: 560,
            height: 30,
            width: 150,
            position: "absolute",
            border: "none",
            background: "white",
            fontSize: "12px",
            color: "#000080",
            fontWeight: "bold",
          }}
        >
          ROLLING SHUTTER
        </div>

        <div
          className="floor-section"
          style={{
            left: 199,
            top: 560,
            height: 20,
            width: 50,
            position: "absolute",
            border: "none",
            background: "white",
            fontSize: "12px",
            color: "#000080",
            fontWeight: "bold",
          }}
        >
          DOOR
        </div>

        <div
          className="floor-section-1"
          style={{
            left: 754,
            top: 1140,
            height: 30,
            width: 250,
            position: "absolute",
          }}
        >
          QA HOLD MATERIAL STORAGE RACK
        </div>

        <div
          className="floor-section-1"
          style={{
            left: 238,
            top: 1142,
            height: 30,
            width: 100,
            position: "absolute",
          }}
        >
          LIFT CAGE
        </div>
        {/* <div
          className="floor-section"
          style={{
            left: -23,
            top: 880,
            height: 30,
            width: 150,
            position: "absolute",
            border: "none",
            background: "white",
          }}
        >
          SLIDING
        </div> */}

        <div
          className="floor-section"
          style={{
            left: "54px",
            top: "930px",
            height: "21px",
            width: "102px",
            position: "absolute",
            border: "none",
            background: "white",
            fontSize: 12,
            color: "#000080",
            fontWeight: "bold",
          }}
        >
          SLIDING DOOR
        </div>
        {/* <div
          className="floor-section"
          style={{
            left: 10,
            top: 1000,
            height: 30,
            width: 200,
            position: "absolute",
          }}
        ></div> */}

        <div
          className="floor-section-1"
          style={{
            border: "none",
            left: "12px",
            top: "977px",
            height: "30px",
            width: "150px",
            zIndex: "999",
            position: "absolute",
          }}
        >
          PHYSIOTHERAPIST <br /> CABIN
        </div>

        <div
          className="floor-section-1"
          style={{
            left: 10,
            top: 975,
            height: 198,
            width: 200,
            position: "absolute",
          }}
        >
          OFFICE
        </div>
      </div>
      <div
        className="floor-plan-container"
        style={{
          width: isFloorPlanZoomed ? "900px" : "-webkit-fill-available",
          left: !isFloorPlanZoomed ? "-73%" : "unset",
          transform: !isFloorPlanZoomed ? "scale(0.40)" : "scale(0.9)",
        }}
      >
        <div className="wall outer-top"></div>
        <div className="wall outer-bottom"></div>
        <div className="wall outer-left"></div>
        <div className="wall outer-right"></div>

        <div
          className={`area chlorination ${
            mergedArray.find((e) => e.device_tag == "EMERGENCY")?.tagValue == 1
              ? "alarm-highlight"
              : ""
          }`}
          onClick={() => {
            if (
              mergedArray.find((e) => e.device_tag == "EMERGENCY")?.tagValue ==
              1
            ) {
              window.location.href = `/alarm?machine_name=${encodeURIComponent("chlorination")}`;
            }
          }}
        >
          CHLORINATION
        </div>

        <div className="room toilet">TOILET</div>
        <div className="label-box goods-lift-top">GOODS LIFT</div>
        <div
          className={`label-box washing-mc ${getAlarmClass(
            getProngOvenTagKey("washing 2")
          )}`}
          onClick={() => handleFloorSectionClick("washing 2","Washing 2")}
         
        >
          WASHING M/C
        </div>
        <div className="room changing-room">CHANGING ROOM</div>
        <div className="room gloves-storage">Gloves Storage</div>
        <div className="room gloves-cabin">GLOVES CABIN</div>
        <div className="room gloves-testing-lab">GLOVES TESTING LAB</div>
        <div className="room product-testing-area">PRODUCT TESTING AREA</div>

        <div
          className={`room ac-conditioning-area-1 ${getAlarmClass(
            getProngOvenTagKey("AC Room 1")
          )}`}
          onClick={() => handleFloorSectionClick("AC Room 1","AC Conditioning")}
         
        >
          AC CONDITIONING AREA
        </div>
        <div className="room final-visual-inspection">
          FINAL VISUAL INSPECTION
        </div>
        <div
          className={`room ac-conditioning-area-2 ${getAlarmClass(
            getProngOvenTagKey("AC Room 2")
          )}`}
          onClick={() => handleFloorSectionClick("AC Room 2","Extra AC Conditioning")}
          
        >
          EXTRA AC CONDITIONING AREA
        </div>
        <div className="room semi-finish-area">Semi Finish Area</div>
        <div className="label-box qr-printing">QR PRINTING</div>
        <div className="label-box packing-area">PACKING AREA</div>
        <div className="label-box dispatch-box-label-printing">
          DISPATCH BOX LABEL PRINTING
        </div>

        <div
          className={`label-box prong-oven-5-top ${getAlarmClass(
            getProngOvenTagKey("Prong Oven 7")
          )}`}
          onClick={() => handleFloorSectionClick("Prong Oven 7","Prong Oven 7")}
         
        >
          PRONG OVEN 7
        </div>
        <div
          className={`label-box prong-oven-8-bottom ${getAlarmClass(
            getProngOvenTagKey("Prong Oven 8")
          )}`}
          onClick={() => handleFloorSectionClick("Prong Oven 8","Prong Oven 8")}
         
        >
          PRONG OVEN 8
        </div>
        <div className="label-box coating-table">Coating Table</div>
        <div className="label-box packing-table">PACKING TABLE</div>
        <div className="label-box loading-bay">Loading Bay</div>
        <div className="room office-area-gateway"></div>
        <div className="room office-area">OFFICE AREA</div>
        <div className="room pilot-lab">PILOT LAB</div>
        <div className="label-box goods-lift-bottom">Goods Lift</div>
        <div
          className="label-box"
          style={{ top: 1060, left: 636, width: 121, height: 116 }}
        >
          QA Incoming Inspection Area
        </div>
        <div
          className="label-box "
          style={{ top: 860, left: 750, width: 150, height: 316 }}
        >
          Space for Container Parking
        </div>
        <div
          className="rotated-text gangway-vertical-1"
          style={{
            transform: "rotate(90deg)",
            position: "absolute",
            fontSize: 12,
            color: "#000080",
            fontWeight: "bold",
          }}
        >
          GANGWAY
        </div>

        <div
          className="rotated-text gangway-vertical-2"
          style={{
            transform: "rotate(90deg)",
            position: "absolute",
            fontSize: 12,
            color: "#000080",
            fontWeight: "bold",
          }}
        >
          GANGWAY
        </div>

        <div
          className="rotated-text gangway-vertical-3"
          style={{
            transform: "rotate(90deg)",
            position: "absolute",
            fontSize: 12,
            color: "#000080",
            fontWeight: "bold",
          }}
        >
          GANGWAY
        </div>

        <div
          className="arrow arrow-gangway-1"
          style={{
            top: 693,
            left: 21,
            position: "absolute",
            fontSize: 12,
            color: "#000080",
            fontWeight: "bold",
          }}
        >
          GANGWAY
        </div>

        <div
          className="arrow arrow-gangway-2"
          style={{
            top: 941,
            left: 21,
            position: "absolute",
            fontSize: 12,
            color: "#000080",
            fontWeight: "bold",
          }}
        >
          GANGWAY
        </div>

        <div
          className="rotated-text electrical-testing-machine"
          style={{
            transform: "rotate(90deg)",
            top: 201,
            left: 511,
            position: "absolute",
          }}
        >
          ELECTRICAL TESTING MACHINE
        </div>

        <div
          className="entry-stairs"
          style={{
            top: 145,
            right: -6,
            width: 40,
            height: 60,
            position: "absolute",
          }}
        ></div>

        <div
          className="arrow-entry"
          style={{
            top: 71,
            right: 0,
            position: "absolute",
            border: "1px solid #000080",
            height: 75,
            width: 104,
            fontSize: 12,
            paddingTop: 12,
          }}
        >
          Solution <br /> Coating <br />
          Area
        </div>

        <div
          className="hatch-area goods-lift-hatch"
          style={{
            top: 1152,
            left: 317,
            width: 20,
            height: 40,
            transform: "rotate(90deg)",
            transformOrigin: "top left",
            position: "absolute",
          }}
        ></div>
      </div>
    </div>
  );
};

export default FloorPlan;
